module.exports = __webpack_public_path__ + "static/img/encased-uranium-cell_256.4dd4fd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/encased-uranium-cell_256.png
// module id = WDZn
// module chunks = 0